import {MENU} from './types';

export function Collapsed(change){
    return(dispatch) => {
        dispatch({type:MENU,payload:change})
    }
}